/**
 * Shared UI component for UI Dialog.
 * PARENT-CHILD CONTRACT: parent screens provide the data and configuration that
 * this wrapper renders or normalizes for reuse across the application.
 */
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';

import { UiButtonComponent } from '../ui-button/ui-button.component';
import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';
import { UiDialogTone } from './ui-dialog.types';

@Component({
  selector: 'ui-dialog',
  standalone: true,
  imports: [DialogModule, UiButtonComponent, UiLabelTranslatePipe],
  templateUrl: './ui-dialog.component.html',
  styleUrl: './ui-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiDialogComponent {
  readonly open = input(false);
  readonly title = input('');
  readonly description = input('');
  readonly tone = input<UiDialogTone>('default');
  readonly confirmLabel = input('Yes');
  readonly cancelLabel = input('No');
  readonly confirmAction = output<void>();
  readonly cancelAction = output<void>();

  onVisibleChange(visible: boolean): void {
    if (!visible) {
      this.cancelAction.emit();
    }
  }
}
